<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import Vue from 'vue'
  import 'babel-polyfill'
  import BootstrapVue from 'bootstrap-vue'
  import '@/assets/style.scss'
  import '@/configs/config_05.js'

  Vue.use(BootstrapVue)


  export default {
    name: 'App',
  }
</script>
